import { useContext, useState } from "react";

import { Grid } from "@material-ui/core";

import Fieldset from "../../../../components/basics/Fieldset";
import TabsErp from "../../../../components/tabs/TabsErp";
import UploadFiles from "../../../../components/uploadFiles/UploadFiles";
import { ChipTitleStyled } from "../styles/GerenciamentoContrato";
import { GerenciamentoContratoContext } from "../contexts/GerenciamentoContratoContext";
import TextField from "../../../../components/basics/TextFieldErp";
import { GlobalVariables } from "../../../../GlobalVariables";

const TabObservacoes = () => {
  const { observation, setObservation } = useContext(
    GerenciamentoContratoContext
  );

  return (
    <>
      <Grid item xs>
        <TextField
          value={observation}
          setValue={setObservation}
          multiline
          rows={10}
          variant="outlined"
        />
      </Grid>
    </>
  );
};

const TabAnexos = () => {
  const { uploadFilesAttachment, setUploadFilesAttachment, modality } =
    useContext(GerenciamentoContratoContext);

  return (
    <>
      <Grid item xs>
        <UploadFiles
          multiple
          accept="image/*,.pdf,.xlsx,.xls,docx"
          label="Clique ou arraste aqui seu arquivo"
          uploadedFiles={uploadFilesAttachment}
          setUploadedFiles={setUploadFilesAttachment}
          maxHeightListSmall={
            modality?.value === GlobalVariables.contract.modality.separate
              ? "80vh"
              : "25vh"
          }
          maxHeightListLarge={
            modality?.value === GlobalVariables.contract.modality.separate
              ? "50vh"
              : "15vh"
          }
          previewFile
          downloadFile
        />
      </Grid>
    </>
  );
};

const AccordionAdicionais = ({ ...props }) => {
  const [tabIndex, setTabIndex] = useState(0);
  const headers = [
    {
      label: "Observação",
    },
    {
      label: "Anexos",
    },
  ];
  const children = [<TabObservacoes key="0" />, <TabAnexos key="1" />];

  return (
    <>
      <Fieldset
        titulo={
          <ChipTitleStyled
            label="ADICIONAIS"
            bgcolor="lightgrey"
            textcolor="black"
          />
        }
        bgcolor="white"
        textcolor="black"
        accordion
      >
        <TabsErp
          headers={headers}
          children={children}
          tabIndex={tabIndex}
          onChange={(event, value) => {
            if (Number.isInteger(value)) setTabIndex(value);
          }}
        />
      </Fieldset>
    </>
  );
};

export default AccordionAdicionais;
